import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import EmployeeDocuments from "./index";
import { FileText } from "lucide-react";

const employeeDocumentsRoutes = [	
    generateCRUDRoutes({
        mainTitle: "My Documents",
        basePath: "documents",
        mainComponent: <EmployeeDocuments />,
        layout: "/console",
        icon: <FileText className="icon-item" />,
        subTitle:"My Document",
        level:5,
        moduleId: 0,
    })
];

export default employeeDocumentsRoutes;